<template>
  <selectable-card :selected="selected" :disableOptions="true" :disableCheckbox="disableCheckbox"
    :disableTooltipText="disableTooltipText" @click:card="cardClicked" @click:checkbox="cardClicked">
    <template v-slot:content>
      <v-container class="text-body-2">
        <v-row>
          <v-col>
            <div class="flex-grow-1">
              <div>PROCEDIMENTO</div>
              <div v-if="faturamentoItem.codigoProcedimento"><b>{{ faturamentoItem.codigoProcedimento | formatNullValue
                  }}</b></div>
              <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
              <span v-else>-</span>
            </div>
          </v-col>
          <v-col>
            <div class="flex-grow-1">
              <div>QUANTIDADE</div>
              <div><b>{{ faturamentoItem.quantidade }}</b></div>
            </div>
          </v-col>
          <v-col>
            <div class="flex-grow-1">
              <div>UNITÁRIO</div>
              <div><b>{{ faturamentoItem.valorUnitario | formatCurrency }}</b></div>
            </div>
          </v-col>
          <v-col>
            <v-chip color="secondary" small>{{ isConciliado ? 'Conciliado' : 'Não conciliado' }}</v-chip>
          </v-col>
        </v-row>

        <v-row align="start">
          <v-col cols="6" class="py-0">
            <div>DESCRIÇÃO</div>
            <div v-if="faturamentoItem.descricaoProcedimento"><b>{{ faturamentoItem.descricaoProcedimento |
              formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
          <v-col cols="3" class="py-0">
            <div>EXECUÇÃO</div>
            <div v-if="faturamentoItem.dataExecucao"><b>{{ faturamentoItem.dataExecucao | formatDate | formatNullValue
                }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
          <v-col cols="3" class="py-0">
            <div>SENHA</div>
            <div v-if="faturamentoItem.senha"><b>{{ faturamentoItem.senha | formatNullValue }}</b></div>
            <v-chip v-else-if="isUsuarioTradimus" small>Indisponível</v-chip>
            <span v-else>-</span>
          </v-col>
        </v-row>

        <v-row v-if="hasFaturamentoEquipe">
          <v-col>
            <div>NOME PROFISSIONAL EXECUTANTE</div>
            <div><b>{{ profissionalExecutanteNome }}</b></div>
          </v-col>
          <v-col>
            <div>CÓD. PROFISSIONAL EXECUTANTE</div>
            <div><b>{{ profissionalExecutanteCodigo }}</b></div>
          </v-col>
          <v-col>
            <div>CÓD. CONSELHO PROFISSIONAL EXECUTANTE</div>
            <div><b>{{ profissionalExecutanteCodigoConselho }}</b></div>
          </v-col>
        </v-row>

        <v-row v-if="isConciliado">
          <v-col>
            <div>
              {{ faturamentoItem.conciliacaoItens.length > 1
                ? ('DATAS DE PAGAMENTOS CONCILIADOS')
                : ('DATA DE PAGAMENTO CONCILIADO')
              }}
            </div>
            <v-row>
              <v-col v-for="(datasConciliacao, tipoPagamento) in datasPagamentoPorTipo" :key="tipoPagamento">
                <b>{{ tipoPagamento }}: </b>{{ datasConciliacao.join(', ') }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div>
              Recursado
            </div>
            <div><b>{{ faturamentoItem.valorRecursado | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>
              Acatado
            </div>
            <div><b>{{ faturamentoItem.valorAcatado | formatCurrency }}</b></div>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div>INFORMADO</div>
            <div><b>{{ faturamentoItem.valor | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>PAGO</div>
            <div class="success--text"><b>{{ faturamentoItem.valorPago | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>GLOSADO</div>
            <div class="red--text"><b>{{ faturamentoItem.valorGlosado | formatCurrency }}</b></div>
          </v-col>
          <v-col>
            <div>SALDO</div>
            <div><b>{{ faturamentoItem.saldo | formatCurrency }}</b></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Guia Operadora</div>
            <div><b>{{ faturamentoItem.numeroGuiaOperadora }}</b></div>
          </v-col>
          <v-col>
            <div>Data Execução</div>
            <div><b>{{ faturamentoItem.dataExecucao | formatDate }}</b></div>
          </v-col>
          <v-col>
            <div>Nº do lote</div>
            <div><b>{{ faturamentoItem.numeroLote }}</b></div>
          </v-col>
          <v-col>
            <div>Data Geração Lote</div>
            <div><b>{{ faturamentoItem.dataGeracaoLote | formatDateTime }}</b></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>Nº do protocolo</div>
            <div><b>{{ faturamentoItem.numeroProtocolo ?? '-' }}</b></div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </selectable-card>
</template>

<style scoped>
.d-flex {
  gap: 8px;
}
</style>

<script>
import { mapGetters } from 'vuex'
import { formatCurrency } from '../../../libs'
import SelectableCard from '../../common/SelectableCard.vue'

export default {
  components: {
    SelectableCard
  },
  props: {
    faturamentoItem: { type: Object, required: true },
    isUsuarioTradimus: Boolean
  },
  computed: {
    ...mapGetters('conciliacao', ['selectedPagamentoItensCount', 'selectedFaturamentoItensCount', 'hasSelectedItemSistema', 'selectedPagamentoItemsSistema']),
    disableCheckboxByNN() {
      return this.selectedPagamentoItensCount > 1 && this.selectedFaturamentoItensCount >= 1 && !this.selected
    },
    faturamentoItemConciliacaoDates() {
      return this.faturamentoItem.conciliacaoItens
        .map(conciliacaoItem => conciliacaoItem.dataPagamento)
        .filter(element => element !== null)
    },
    faturamentoItemHasSameDateConciliacaoThanPagamentoItemSistema() {
      const selectedPagamentoItensDates = this.selectedPagamentoItemsSistema
        .map(pagamentoItem => pagamentoItem.dataPagamento)

      return this.faturamentoItemConciliacaoDates
        .filter(date => selectedPagamentoItensDates.includes(date))
        .length > 0
    },
    disableCheckboxByItemSistema() {
      return this.hasSelectedItemSistema && this.faturamentoItemHasSameDateConciliacaoThanPagamentoItemSistema
    },
    disableCheckbox() {
      return this.disableCheckboxByNN || this.disableCheckboxByItemSistema
    },
    disableTooltipText() {
      if (this.disableCheckboxByNN) {
        return 'Não é possível selecionar mais de um item.'
      } else if (this.disableCheckboxByItemSistema) {
        return 'Não é permitido conciliar um item resto de guia com um item faturado já conciliado do mesmo pagamento.'
      } else {
        return ''
      }
    },
    selected() {
      return this.$store.getters['conciliacao/isFaturamentoItemSelected'](this.faturamentoItem.id)
    },
    isConciliado() {
      return Boolean(this.faturamentoItem.conciliacaoItens?.length)
    },
    hasFaturamentoEquipe() {
      return this.faturamentoItem.faturamentoEquipes?.length > 0
    },
    profissionalExecutanteNome() {
      const nomes = this.faturamentoItem.faturamentoEquipes.map(profissional => profissional.profissionalNome)
      return nomes.join(', ')
    },
    profissionalExecutanteCodigo() {
      const codigos = this.faturamentoItem.faturamentoEquipes.map(profissional => profissional.profissionalCodigo)
      return codigos.join(', ')
    },
    profissionalExecutanteCodigoConselho() {
      const codigos = this.faturamentoItem.faturamentoEquipes.map(profissional => profissional.conselhoProfissionalNumero)
      return codigos.join(', ')
    },
    datasPagamentoPorTipo() {
      const datasPagamentoPorTipo = {};

      this.faturamentoItem.conciliacaoItens.map(item => {
        const tipoPagamento = item.tipoPagamento;
        const dataConciliacao = this.formatDataPagamentoConciliado(item.dataPagamento);
        if (!datasPagamentoPorTipo[tipoPagamento]) {
          datasPagamentoPorTipo[tipoPagamento] = [];
        }
        datasPagamentoPorTipo[tipoPagamento].push(dataConciliacao);
      });
      return datasPagamentoPorTipo;
    },
  },
  methods: {
    cardClicked() {
      this.$emit('click:card', this.faturamentoItem, this.selected)
    },
    formatDataPagamentoConciliado(date) {
      if (!date) return null
      date = date.substr(0, 10)
      const [year, month, day] = date.split("-")
      return `${day}/${month}/${year}`
    }
  },
  filters: {
    formatCurrency(value) {
      return formatCurrency(value)
    },
    formatDate(dataISO) {
      if (!dataISO) return '-'
      const [data] = dataISO.split('T');
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano}`;
    },
    formatDateTime(dataHoraISO) {
      const [data, hora] = dataHoraISO.split(' ');
      const [ano, mes, dia] = data.split('-');
      return `${dia}/${mes}/${ano} ${hora}`;
    }

  }
}
</script>
